import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallbackPage() {
  const { handleAuth0Callback, setAuth } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [error, setError] = useState('');
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Check for Google Auth session_id in URL fragment
      const hash = window.location.hash;
      if (hash && hash.includes('session_id=')) {
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];
        if (sessionId) {
          try {
            const res = await axios.post(`${API}/api/auth/google-callback`, { session_id: sessionId });
            if (res.data.token) {
              localStorage.setItem('xdx_token', res.data.token);
              axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
              // Clear the hash
              window.history.replaceState(null, '', window.location.pathname);
              window.location.href = '/dashboard';
              return;
            }
          } catch (err) {
            setError(err.response?.data?.detail || 'Google authentication failed.');
            return;
          }
        }
      }

      // Check for Auth0 code in query params
      const code = searchParams.get('code');
      if (code) {
        try {
          await handleAuth0Callback(code);
          navigate('/dashboard');
        } catch {
          setError('Authentication failed. Please try again.');
        }
        return;
      }

      setError('No authentication data received.');
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      {error ? (
        <div className="text-center" data-testid="auth-callback-error">
          <p className="text-red-400 mb-4">{error}</p>
          <button onClick={() => navigate('/login')} className="text-[#00E5FF] hover:underline" data-testid="back-to-login-btn">Back to Login</button>
        </div>
      ) : (
        <div className="text-center" data-testid="auth-callback-loading">
          <Loader2 className="h-8 w-8 animate-spin text-[#00E5FF] mx-auto mb-4" />
          <p className="text-zinc-400">Authenticating...</p>
        </div>
      )}
    </div>
  );
}
